import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface AlertCardSectionTitleProps {
  title: string
  onClick: () => void
  endIcon?: React.ReactNode
}

// Clickable section heading inside an alert card body
const AlertCardSectionTitle: React.FC<AlertCardSectionTitleProps> = ({
  title,
  onClick,
  endIcon,
}) => {
  const theme = useTheme()

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.25,
        alignSelf: 'flex-start',
        cursor: 'pointer',
        borderRadius: 1,
        px: 0.5,
        mx: -0.5,
        mb: 0.5,
        color: theme.palette.text.primary,
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)', color: theme.palette.primary.main },
      }}
    >
      <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>{title}</Typography>
      {endIcon}
    </Box>
  )
}

export default AlertCardSectionTitle
